import { useAuthUserStore } from "@/stores/authUser";
export default function parentOnly() {
    const authUserStore = useAuthUserStore();
    const u = authUserStore.user;
    if (u && u.level < 3) {
        return;
    }

    return {
        name: "launch"
    };
}
